// import { useEffect } from 'react';
// import { useFirebaseAuth } from '@/contexts/FirebaseAuthContext';

export default function PushRegister() {
  // const { user, loading } = useFirebaseAuth();

  return null;
}
